import { useMutation } from "react-query";
import Modal from "../../common/components/Modal";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import useSubscribers from "../../common/hooks/pages/useSubscribers";
import { usePopup } from "../../common/contexts/PopupContext";
import Loader from "../../common/components/Loading";
function getFormInputs(email) {
  return [
    {
      type: "text",
      label: "Email",
      name: "email",
      placeholder: "Email",
      validation: {
        required: "Email is required",
      },
      defaultValue: email,
    },
  ];
}

function SubscriberForm({
  open,
  setOpen,
  title,
  onSuccess,
  subscriberId,
  email,
}) {
  const { addSubscriber, updateSubscriber } = useSubscribers();
  const { toast } = usePopup();

  const { mutate: createSubscriberMutation, isLoading: isCreating } =
    useMutation({
      mutationFn: addSubscriber,
      onSuccess: (res) => {
        const { message } = res?.data || {};
        if (onSuccess) {
          onSuccess();
        }
        toast(message || "Subscriber added successfully", "success");
        setOpen(false);
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Failed to add subscriber. Please try again later.";
        toast(message, "error");
      },
    });

  const { mutate: updateSubscriberMutation, isLoading: isUpdating } =
    useMutation({
      mutationFn: updateSubscriber,
      onSuccess: (res) => {
        const { message } = res?.data || {};
        if (onSuccess) {
          onSuccess();
        }
        toast(message || "Subscriber updated successfully", "success");
        setOpen(false);
      },
      onError: (error) => {
        const message =
          error?.response?.data?.message ||
          "Failed to update subscriber. Please try again later.";
        toast(message, "error");
      },
    });

  return (
    <Modal
      title={title || `${subscriberId ? "Update" : "Add"} Subscriber`}
      open={open}
      setOpen={setOpen}
    >
      {isCreating || isUpdating ? (
        <Loader />
      ) : (
        <FormBuilder
          formInputs={getFormInputs(email)}
          submitButtonLabel={subscriberId ? "Update" : "Submit"}
          onSubmit={(data) => {
            if (subscriberId) {
              const variables = {
                payload: data,
                subscriberId,
              };
              updateSubscriberMutation(variables);
            } else {
              createSubscriberMutation(data);
            }
          }}
          submitBtnContainerCls="!my-2"
        />
      )}
    </Modal>
  );
}

export default SubscriberForm;
